import React from 'react'
import './HoldingAdvantages.css'

function HoldingAdvantages() {
  return <section className="Holding-Advantages">
    <div className="Holding-Advantages-container">
      <div className="Holding-Advantages-advantage">
        <p className="Holding-Advantages-advantage__title">топ-5</p>
        <p className="Holding-Advantages-advantage__description">
          телекоммуникационных компаний в России
        </p>
      </div>
      <div className="Holding-Advantages-advantage">
        <p className="Holding-Advantages-advantage__title">№1</p>
        <p className="Holding-Advantages-advantage__description">
          самый быстрорастущий российский оператор
        </p>
      </div>
      <div className="Holding-Advantages-advantage">
        <p className="Holding-Advantages-advantage__title">№1</p>
        <p className="Holding-Advantages-advantage__description">
          по средней скорости доступа в интернет
        </p>
      </div>
      <div className="Holding-Advantages-advantage">
        <p className="Holding-Advantages-advantage__title">№2</p>
        <p className="Holding-Advantages-advantage__description">
          по масштабам фиксированного бизнеса в стране
        </p>
      </div>
    </div>
  </section>
}

export default HoldingAdvantages;


// WEBPACK FOOTER //
// ./src/components/HoldingAdvantages/index.js